import { render, staticRenderFns } from "./ActiveHotels.vue?vue&type=template&id=3142413c&scoped=true&"
import script from "./ActiveHotels.vue?vue&type=script&lang=js&"
export * from "./ActiveHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3142413c",
  null
  
)

export default component.exports